// frappe code to make the page top bar dark
frappe.ready(() => {
	$(".navbar").removeClass("navbar-light bg-white").addClass("navbar-dark bg-dark");
});
